/* Mahi Wairua — load heavy previews only when customers open them, and never leave a dead button.
   Loaded in <head> with defer, so it runs before the product-page preview scripts.
   - Wall preview (metal prints): the room-card artwork is prepared only when the cards come near the screen,
     not on page load. Opening the preview prepares it straight away.
   - Wall preview buttons: if the preview script hasn't loaded yet, wait briefly; if it never loads, say so
     and point the customer back to Add to cart.
   - 3D tee and 3D metal print: if 3D hasn't drawn 20 seconds after the tab is opened, show the photo fallback.
   Buying never depends on any of this: the product form and Add to cart are plain theme HTML. */
(function () {
  'use strict';
  if (!window.customElements) return;

  var WAIT_MS = 10000, TIMEOUT_3D = 20000;

  /* ---------- 1. Wall preview: prepare room-card artwork when it is about to be seen ---------- */
  function patchWall(cls) {
    try {
      var proto = cls && cls.prototype, orig = proto && proto.refreshMiniArtwork;
      if (!orig || orig._mwLazy) return;
      var lazy = function () {
        var self = this, args = arguments;
        if (self._mwSeen || self.source === 'studio' || (self.dialog && self.dialog.open) || !('IntersectionObserver' in window)) {
          return orig.apply(self, args);
        }
        if (self._mwWaiting) return;
        var target = self.querySelector('[data-wall-room-launch]') || self._movedLaunch || self;
        self._mwWaiting = true;
        var io = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          io.disconnect(); self._mwSeen = true; self._mwWaiting = false;
          if (self.isConnected) orig.call(self);
        }, { rootMargin: '300px 0px' });
        io.observe(target);
      };
      lazy._mwLazy = true;
      proto.refreshMiniArtwork = lazy;
      // Opening the preview always prepares the artwork immediately.
      var origOpen = proto.open;
      if (origOpen && !origOpen._mwLazy) {
        proto.open = function () { this._mwSeen = true; return origOpen.apply(this, arguments); };
        proto.open._mwLazy = true;
      }
    } catch (e) { /* leave the original behaviour in place */ }
  }
  var define = customElements.define;
  try {
    customElements.define = function (name, cls) {
      if (name === 'mahi-wall-preview') patchWall(cls);
      return define.apply(this, arguments);
    };
  } catch (e) { /* some browsers lock define; the preview still works, just not lazily */ }

  /* ---------- 2. Wall preview buttons pressed before the script is ready ---------- */
  function note(btn, text) {
    var holder = btn.closest('mahi-wall-preview') || btn.parentNode, p = holder && holder.querySelector('[data-mw-load-note]');
    if (!holder) return;
    if (!p) {
      p = document.createElement('p'); p.setAttribute('data-mw-load-note', ''); p.setAttribute('role', 'status');
      p.className = 'mw-wall__hint'; holder.appendChild(p);
    }
    p.textContent = text;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wall-open], [data-wall-room-open]');
    if (!btn || customElements.get('mahi-wall-preview') || btn._mwPending) return;
    e.preventDefault(); e.stopImmediatePropagation();
    btn._mwPending = true; btn.setAttribute('aria-busy', 'true');
    note(btn, 'Loading the preview…');
    var done = false, timer = setTimeout(function () {
      if (done) return; done = true; btn._mwPending = false; btn.removeAttribute('aria-busy');
      note(btn, 'The preview couldn’t load on this connection. You can still choose your options and add to cart.');
    }, WAIT_MS);
    customElements.whenDefined('mahi-wall-preview').then(function () {
      if (done) return; done = true; clearTimeout(timer); btn._mwPending = false; btn.removeAttribute('aria-busy');
      note(btn, '');
      requestAnimationFrame(function () { btn.click(); });
    });
  }, true);

  /* ---------- 3. 3D watchdog: fall back to photos if 3D hasn't drawn in time ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('mahi-tee-tabs [data-tab="3d"], mahi-metal-viewer [data-mv-tab="3d"]');
    if (!tab || tab._mwWatch) return;
    tab._mwWatch = true;
    setTimeout(function () {
      tab._mwWatch = false;
      try {
        var tee = tab.closest('mahi-tee-tabs'), metal = tab.closest('mahi-metal-viewer');
        if (tee) {
          var el = tee.querySelector('mahi-tee-real');
          if (el && el.started && !el.ready && typeof el.fail === 'function') {
            el.fail();
            var t = el.querySelector('[data-fallback] p'); if (t) t.textContent = 'The 3D tee is taking too long to load. The photos show the tee instead.';
          }
        } else if (metal && metal._3dStarted && !metal._texReady && typeof metal._fail === 'function') {
          metal._fail('The 3D view is taking too long to load. The photos show the print instead.');
        }
      } catch (err) { /* never block the page */ }
    }, TIMEOUT_3D);
  }, true);
})();
